import { cn } from "@/lib/utils"
import { Card, CardContent } from "@/components/ui/card"

interface AdminStatsCardProps {
  icon: React.ReactNode
  label: string
  value: string | number
  valueClassName?: string
}

export function AdminStatsCard({ icon, label, value, valueClassName }: AdminStatsCardProps) {
  return (
    <Card className="transition-shadow hover:shadow-sm">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
          {icon}
          <span>{label}</span>
        </div>
        <p className={cn("text-2xl font-semibold text-foreground", valueClassName)}>
          {value}
        </p>
      </CardContent>
    </Card>
  )
}
